import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
import { PostAlert } from "./AlertActions";
import { getRoleList } from "../state/roleListSlice";
import { getRole, saveRole, createRole, deleteRole, deleteFailedRole } from "../state/roleSlice";
export function GetRoleList(dispatch) {
  axios.get(`${Globals.baseUrl}/Roles/GetRoles`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatch(getRoleList(res.data));
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetBPList() {
  axios.get(`${Globals.baseUrl}/Roles/GetBPList`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.RoleBPGetList,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((res) => {
    console.log("error");
    console.log(res.response);
  });
}
export function GetRole(roleId) {
  axios.get(`${Globals.baseUrl}/Roles/GetRole/${roleId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.RolesGetOne,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetRole2(roleId, dispatch) {
  axios.get(`${Globals.baseUrl}/Roles/GetRole/${roleId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatch(getRole(res.data));
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetUsersInRole(roleId) {
  axios.get(`${Globals.baseUrl}/Roles/GetUsersInRole/${roleId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.RolesGetUsers,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetUsersForRole2(roleId, dispatch) {
  axios.get(`${Globals.baseUrl}/Roles/GetUsers/${roleId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatch(getRole(res.data));
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetUsersForRole(roleId) {
  axios.get(`${Globals.baseUrl}/Roles/GetUsersForRole/${roleId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.RolesUsersFor,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function SaveRole(role, permissions, wfStepRp, bpId, grps) {
  axios.post(
    `${Globals.baseUrl}/Roles/UpdateRole`,
    {
      Role: role,
      Permissions: permissions,
      wfStepRp,
      businessProcessId: bpId,
      groups: grps
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.RolesUpdateOne,
        Result: res.data
      });
      PostAlert("success", "Role updated");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function SaveRole2(dispatch, role, permissions, wfStepRp, bpId, grps) {
  axios.post(
    `${Globals.baseUrl}/Roles/UpdateRole2`,
    {
      Role: role,
      Permissions: permissions,
      wfStepRp,
      businessProcessId: bpId,
      groups: grps
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      if (res.data.type === "New") {
        dispatch(createRole(res.data.role));
        GetRoleList(dispatch);
      } else {
        dispatch(saveRole(res.data.role));
      }
      PostAlert("success", "Role updated");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function UpdateUsersInRole(role, users) {
  axios.post(
    `${Globals.baseUrl}/Roles/UpdateUsersInRole`,
    {
      roleId: parseInt(role, 10),
      users
    },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      console.log("dispatch");
      dispatcher.dispatch({
        actionType: actionTypes.RolesUpdateUsers,
        Result: res.data
      });
      PostAlert("success", "Role users updated");
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function DeleteRole(id) {
  axios.get(`${Globals.baseUrl}/Roles/DeleteRole/${id}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      console.log(res.data);
      if (res.data.deleteStatus === "error") {
        PostAlert("error", res.data.deleteMessage);
      } else {
        console.log("dispatch");
        dispatcher.dispatch({
          actionType: actionTypes.RolesDeleteOne,
          Result: res.data
        });
        PostAlert("success", "Role deleted");
      }
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function DeleteRole2(id, dispatch) {
  axios.get(`${Globals.baseUrl}/Roles/DeleteRole/${id}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      if (res.data.deleteStatus === "error") {
        dispatch(deleteFailedRole(res.data.deleteMessage));
        PostAlert("error", res.data.deleteMessage);
      } else {
        dispatch(deleteRole());
        PostAlert("success", "Role deleted");
      }
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
